export default defineNuxtPlugin((nuxtApp) => {
  const config = useSofieConfig();

  nuxtApp.hook('apollo:headers', (headers) => {
    headers.value['Sofie-Required-Version'] = config.requiredVersion;
  });
});
